import { IHttpApi } from '@cian/http-api/shared';

import { ResponseError } from '../../errors';
import {
  fetchGetQuestions,
  IGetQuestionsRequest,
  IGetQuestionsResponse200,
  IGetQuestionsResponse400,
} from '../../repositories/newbuilding-reviews/v1/get-questions';
import { prepareQuestions } from '../../mappers/prepareQuestions';

export interface IFetchReviewsParams {
  httpApi: IHttpApi;
  parameters: IGetQuestionsRequest;
}

export async function fetchQuestions({ httpApi, parameters }: IFetchReviewsParams) {
  const result = await fetchGetQuestions<IGetQuestionsResponse200, IGetQuestionsResponse400>({
    httpApi,
    parameters,
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'questions#fetchQuestions',
      message: result.response.message as string,
    });
  }

  return prepareQuestions(result.response);
}
